import styled from 'styled-components';


export const MainContainer = styled.div`
    display: flex;
    position: fixed;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle at 40% -25%, rgb(154, 187, 207) 10%, transparent 30%), 
    radial-gradient(circle at 110% 60%, rgb(154, 187, 207) 1%, transparent 25%), 
    radial-gradient(circle at 0% 100%, rgb(154, 187, 207) 1%, rgb(250, 250, 250) 25%)
`;

export const Container = styled.div`
    position: relative;
    width: 50rem;
    height: 30rem;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    box-shadow: 0 0 1rem 0 rgba(0, 0, 0, 0.1);
    border-radius: 0.5rem;
`;

export const TalentLogo = styled.img`
    position: absolute;
    top: 1.5rem;
    left: 50%;
    transform: translateX(-50%);
`;
